/**
 * Redwood theme.
 */
import { Theme } from "@oui/system/theme"
import * as icons from "./Icons"
import * as components from "./components"
import globalStyles from "./globalStyles"
import spacing from "./spacing"
import colors from "./colors"
import breakpoints from "./breakpoints"
import palettes from "./palettes"
import elevations from "./elevations"

const theme: Theme = {
  breakpoints,
  colors,
  components,
  direction: "ltr",
  elevations,
  globalStyles,
  icons,
  name: "Redwood",
  palettes,
  spacing
}

export default theme
